import React from 'react';

import ErrorMessage from '../../../Shared/Components/ErrorMessage';

const Behpardakht = ({ serverErrors, handleChange, errors, values }) => {
  return (
    <>
      <div className='col-12 col-md-6'>
        <div className='form-group'>
          <label className='form-label'>شماره پایانه</label>
          <input
            name='terminal_id'
            type='text'
            className='form-control'
            onChange={handleChange}
            value={values?.terminal_id}
          />
          <ErrorMessage
            error={
              serverErrors?.terminal_id
                ? serverErrors?.terminal_id
                : errors?.terminal_id
            }
          />
        </div>
      </div>
      <div className='col-12 col-md-6'>
        <div className='form-group'>
          <label className='form-label'>نام کاربری</label>
          <input
            name='username'
            type='text'
            className='form-control'
            onChange={handleChange}
            value={values?.username}
          />
          <ErrorMessage
            error={
              serverErrors?.username ? serverErrors?.username : errors?.username
            }
          />
        </div>
      </div>
      <div className='col-12 col-md-6'>
        <div className='form-group'>
          <label className='form-label'>کلمه عبور</label>
          <input
            name='password'
            type='password'
            value={values?.password}
            className='form-control'
            onChange={handleChange}
          />
          <ErrorMessage
            error={
              serverErrors?.password ? serverErrors?.password : errors?.password
            }
          />
        </div>
      </div>
      <div className='col-12 col-md-6'>
        <div className='form-group'>
          <label className='form-label'>آدرس بازگشت از درگاه</label>
          <input
            type='text'
            className='form-control'
            value={values?.callback_url}
            name='callback_url'
            onChange={handleChange}
          />
          <ErrorMessage
            error={
              serverErrors?.callback_url
                ? serverErrors.callback_url
                : errors?.callback_url
            }
          />
        </div>
      </div>
    </>
  );
};

export default Behpardakht;
